
export default async function adminAction({request})
{
    
    const data=await request.formData()
    const login= data.get('login')
    const password = data.get('password')
    const encrypted_login=btoa(login+":"+password)
    const authorization='Basic '+encrypted_login
    try{
        
        const response = await fetch('/server/requests/authenticate.php',{
            method: 'GET',
            credentials: 'include',
            headers: {
                "Authorization": authorization,
                "Token": authorization
            }
        })
        if(response.ok)
        {
           
            const log= await response.json()
           
            return (log ? {message:'logowanie udane', login: login, password: password, value: true} : {message: 'Wprowadzone dane są niepoprawne', value: false})
        }
        else{
            throw new Error('Wystąpił błąd serwera')
        }

    }catch(e){
        console.log(e.message)
        return {message: 'Wystąpił błąd', value: false}
    }

}